import React, {useState, useEffect, forwardRef, useRef} from 'react';
import { useSelector,useDispatch } from 'react-redux'
import TextField from '@mui/material/TextField'; //actualizacion nodejs
import Autocomplete from '@mui/material/Autocomplete'; // nodejs
import Button from '@mui/material/Button'; //atualización
import Paper from '@mui/material/Paper'; ////actualizacion nodejs
import { styled  } from '@mui/material/styles';
import types from '../../actions/types'
import Typography from '@mui/material/Typography'; //actualizacion nodejs
import Divider from '@mui/material/Divider'; //actualizacion nodejs
import { formatCurrency, retardo } from '../../utils/validations'
import Radio from '@mui/material/Radio'; //actualizacion nodejs
import { setTicket, getLastTicket } from '../../components/API';
import Snackbar from '@mui/material/Snackbar'; //actualizacion nodejs
import MuiAlert from '@mui/material/Alert'; //actualizacion nodejs
import RadioGroup from '@mui/material/RadioGroup'; //act nodejs
import FormControlLabel from '@mui/material/FormControlLabel';
import Table from '@mui/material/Table'; //actualizacion nodejs
import TableBody from '@mui/material/TableBody'; //act nodejs
import TableCell from '@mui/material/TableCell'; //actualziacion nodejs
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead'; //ACT NODEJS
import TableRow from '@mui/material/TableRow'; //actualziacion nodejs
import Dialog from '@mui/material/Dialog'; //actualizacion nodejs
import DialogActions from '@mui/material/DialogActions'; //actualizacion nodejs
import DialogContent from '@mui/material/DialogContent'; //actualizacion nodejs
import DialogContentText from '@mui/material/DialogContentText'; //actualizacion nodejs
import DialogTitle from '@mui/material/DialogTitle'; //actualizacion nodejs
import CircularProgress from '@mui/material/CircularProgress'; //actualizacion node js
import ListItem from '@mui/material/ListItem';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import CreatePDF from '../../components/PDF';
import moment from 'moment';
import 'moment/locale/es';
import './index.css'
import firebase from '../../utils/firebase';
import 'firebase/storage';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

const CustomAutocomplete = styled(Autocomplete)( {
  '& .MuiAutocomplete-option': {
    fontSize: 15,
    '& > span': {
      marginRight: 10,
      fontSize: 18,
    },
  },
  minWidth: 270, 
  width: '100%',
});

const AutocompleteCuentas = styled(Autocomplete)({
  minWidth: 270,
  width: '100%', 
  alignContent:"center",
});

const CustomMain = styled('main')({
    margin: '1rem',
    marginLeft: 16,
    marginRight: 16,
     '@media (min-width: 656px)': {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
});

const CustomPaper = styled(Paper)({
  marginTop: 16,
  marginBottom: 16,
  padding: 16,
  '@media (min-width: 656px)': {
    marginTop: 48,
    marginBottom: 48,
    padding: 16,
  },
});


export default function Captura(props) {
  let {clienteCobrar} = props;
  const {syncs} =  useSelector(state=>{ return state });
  let logo = syncs.configuracion.logo;
  const [cliente, setCliente] = useState(props.clienteCobrar ?? null);
  const [moneda, setMoneda] = useState('MXN');
  const [formaPago, setFormaPago] =  useState('Efectivo');
  const [referenciahay, setreferenciahay] =  useState(false);
  const [nombrePGL, setNombrePGL] =  useState('');
  const [listaMoneda, setListaMoneda] = useState([]);
  const [ListaFormaPago, setListaFormaPago] =  useState([]);
  const [referencia, setReferencia] =  useState('');
  const [importe, setImporte] =  useState('');
  const [restanteImporte, setRestanteImporte] =  useState(0);
  const [abonoMaximo, setAbonoMaximo] =  useState(0);
  const [descripcion, setDescripcion] =  useState("");
  const [tipoCambio, setTipoCambio] =  useState("1");
  const [visible, setVisible] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [ cargando, setCargando ] = useState(false); 
  const dispatch  = useDispatch();
  const [num_ticket, setNum_ticket] = useState(1);
  const [usuario, setUsuario] = useState("");
  let { facturas } = cliente && cliente.facturas? cliente: [];
  const [saldoAFavor, setSaldoAFavor] = useState(facturas && facturas.length>0?types.FORMA_FATURAS:types.FORMA_ABONO);
  const [saldoAFavorVisible, setSaldoAFavorVisible] = useState(false);
  const showDialogSaldoAFavorVisible = () => setSaldoAFavorVisible(!saldoAFavorVisible);
  const [clientes, setClientes] = useState([]);
  const [open, setOpen] = useState(false);
  const [visibleDiv, setVisibleDiv] = useState(false);
  const [progress, setProgress] = useState(0);
  const [ticketPDF, setTicketPDF] =  useState('');
  const [otrasFact, setOtrasFact] = useState([]);
  const { vendedor } = syncs && syncs.vendedor? syncs: false;
  const { enviarCorreo } = syncs.configuracion;
  const [print, setPrint] = useState(false);
  
  const [idFormaPago, setIdFormaPago] =  useState("01"); //rz declaramos la variable del id forma de pago
  const [cuentas, setCuentas] = useState([]); //rz declaramos la variable para guardar cuentas de firebase
  const [cuenta, setCuenta] = useState(""); //rz variable para el nombre cuenta
  const [idCuenta, setIdCuenta] = useState(""); //rz variable para el id cuenta
  let info = {};
  const fileInputRef = useRef();
  const [comprobanteFile, setComprobanteFile] = useState(null);
  const [comprobanteName, setComprobanteName] = useState('Sin comprobante');
  const [comprobanteLoaded, setComprobanteLoaded] = useState(false);


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setVisible(false);
  };

  const validFileType = (name, type) => {
    const allowedExt = ['png','jpeg','jpg','pdf'];
    const parts = name.split('.');
    const ext = parts.length>1? parts.pop().toLowerCase() : '';
    if (allowedExt.includes(ext)) return true;
    if (type && type.indexOf('image') !== -1) return true;
    return false;
  }

  const handleSelectComprobante = (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const file = files[0];
    const name = file.name || '';
    if (!validFileType(name, file.type)){
      setMensaje('error! solo formatos de imagen');
      setVisible(true);
      return;
    }
    setComprobanteFile(file);
    setComprobanteName(name);
    setComprobanteLoaded(true);
  }

  const triggerSelectComprobante = () => {
    if (fileInputRef && fileInputRef.current) fileInputRef.current.click();
  }

  const handleClosePdf = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    setPrint(false);
  };

  useEffect(() => {
    let data = syncs.clientes;
    data.filter(element => element.facturas.length>0);
    setClientes(data);
  },);

  /* rz2 Para obtener cuentas de firebase */
  useEffect(() => {
    let cuentas = syncs.configuracion.cuentas; //obtener la info de cuentas de firebase por syncs
    //console.log("useEffect: como obtine clientes= "+JSON.stringify(cuentas));//rzc */
    setCuentas(cuentas);
  },);

  useEffect(() => {
    let tickets = syncs.tickets;
    let { configuracion } = syncs;
    setUsuario(syncs.vendedor.email.split("@")[0]);
    setListaMoneda(configuracion.monedas);
    setListaFormaPago(configuracion.forma_pago); //rz Aqui obtiene la forma de pago
    let num_ticketTmp = (Math.max.apply(Math, tickets.map(function(o) { return o.num_ticket; }))) + 1;
    if (num_ticketTmp === Number.NEGATIVE_INFINITY || num_ticketTmp === Number.POSITIVE_INFINITY){
      num_ticketTmp = 1;
    }
    setNum_ticket(num_ticketTmp);
    ///setSaldoAFavor(facturas && facturas.length>0?types.FORMA_FATURAS:types.FORMA_ABONO);
    //console.log(ListaFormaPago, listaMoneda, num_ticket)
  }, );

  useEffect(() => {
    listaMoneda.map(function (monedaLista){
      //console.log(monedaLista)
      if(monedaLista.nombre === moneda){
        setTipoCambio(monedaLista.valor_peso);
      }
    });
  }, [moneda]);

  async function getTicketsFacturas () {
    let tickets = await syncs.tickets;
    if (cliente && cliente.NAME1){
      setNombrePGL(cliente.NAME1.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}))
    }
    let abonoMaximoTMP = 0;
    //console.log("que pex")
    if( facturas ) {
      setSaldoAFavor(facturas && facturas.length>0?types.FORMA_FATURAS:types.FORMA_ABONO);
      facturas.sort(function(a,b){
        return new Date(a.BUDAT) - new Date(b.BUDAT);
      });
      await facturas.forEach(async (element) => { //Itero las facturas del cliente
        let tmpElement = element;
        element.abono = 0;
        let tmpSaldo = parseFloat(tmpElement.WRBTR);
        let abonoFactura = 0;
        if ( tickets.length > 0){
          const result = tickets.filter(tick =>tick.cliente === cliente.KUNNR);
          let ab = 0;
          result.forEach(fact_ticket => { //Itero los tickets donde aparece el cliente
            if (fact_ticket.cancelado === "0" && fact_ticket.rechazado === "0"){
              fact_ticket.facturas_abono.forEach(fact_pago =>{ // Itero las facturas del ticket
                //console.log("facturas_ticket", fact_pago,"facturas cliente",tmpElement)
                if (parseFloat(element.WRBTR) >= parseFloat(fact_pago.WRBTR)){
                  //console.log("entro")
                  if(fact_pago.BELNR === tmpElement.BELNR){
                    ab = parseFloat(ab) + parseFloat(fact_pago.abono);
                  }
                }
              })
            }
          });
          abonoFactura = parseFloat(ab).toFixed(2); //Recortar a 2 decimales para evitar saldo negativo por decimales
          //console.log("total", ab);
          tmpElement.tmp_saldo =  tmpSaldo - abonoFactura;
          ///console.log(ab);
          //console.log("aaaa", abonoFactura)
        }else{
          tmpElement.tmp_saldo =  tmpElement.WRBTR;
        }
        abonoMaximoTMP = abonoMaximoTMP + parseFloat(tmpElement.tmp_saldo);
        //console.log("factura", tmpElement.BELNR, "total", parseFloat(tmpElement.DMBTR), "abono", abonoFactura, "saldo",parseFloat(tmpElement.tmp_saldo))
      });
      setAbonoMaximo(abonoMaximoTMP);
    }
  }

  useEffect(() => {
    //console.log("entro")
    setRestanteImporte(0)
    getTicketsFacturas();
    setImporte(0)
    //console.log(facturas)
  }, [cliente, syncs]);

  const handlePick = (e, v) => {
    setCliente(v);
    dispatch({type:"CLIENTE_COBRAR", payload: { clienteCobrar:null } });
  };

  /* rz Para ver si ayuda a seleccionar una cuenta */
   const handlePickCount = (e, v) => {
    //console.log("lo que envia el handlePickCount=" + JSON.stringify(v.nombreCuenta));
    //console.log("lo que envia el handlePickCount=" + JSON.stringify(v.idCuenta));
    if (v) {
      setCuenta(v.nombreCuenta); //rz guardar el valor id de cuenta
      setIdCuenta(v.idCuenta); //rz guardar el nombre de cuenta
    } else {
      setCuenta('');
      setIdCuenta('');
    }
  }; 

  // Helper to format how each cuenta appears in the select
  const formatCuentaLabel = (option) => {
    if (!option) return '';
    const id = option.idCuenta + "";
    switch (id) {
      case '113501':
        return 'BBVA MXN 1664107';
      case '114501':
        return 'BBVA USD 1664204';
      case '113511':
        return 'BANAMEX MXN 5008530';
      case '114511':
        return 'BANAMEX USD 9990389';
      case '113551':
        return 'AZTECA MXN 13407';
      default:
        return option?.idCuenta && option?.nombreCuenta ? `${option.idCuenta} - ${option.nombreCuenta}` : '';
    }
  }

  // derive selected option object so Autocomplete keeps the selected value visible
  const selectedCuentaObj = cuentas && cuentas.length > 0 && idCuenta
    ? cuentas.find(c => (c.idCuenta + "") === (idCuenta + "")) || null
    : null;

  const handleChangeMetodo = (event) => {
    setFormaPago(event.target.value);
    getIdFormaPago(event.target.value); //rz mandamos valor para obtener id de forma de pago
  };

  const handleChangeMoneda = (event) => {
    setMoneda(event.target.value);
  };

  const handleChangeImporte = (event) => {
    getImporte(event.target.value);
  };

  const handleChangeImporteFact = (fact, event) => {
    setImporteAbono(fact, event.target.value);
  };

  const handleChangeImporteFactClick = (fact, e) => {
    let Moneytmp = fact.tmp_saldo;
    if (restanteImporte < Moneytmp && restanteImporte > 0){
      Moneytmp= restanteImporte;
    }
    //console.log(fact, Moneytmp);
    setImporteAbono(fact, Moneytmp);
  }

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleChangeReferencia = (event) => {
    setReferencia(event.target.value);
  };

  const handleChangeNombrePGL = (event) => {
    setNombrePGL(event.target.value);
  };

  const getImporte = (value) =>{
    let abono = 0;
    //console.log(value)
    facturas.forEach(element => {
      element.abono = 0;
    });
    listaMoneda.map(function (monedaLista){
      //console.log(monedaLista)
      if(monedaLista.nombre === moneda){
        abono = parseFloat(value) * parseFloat(monedaLista.valor_peso);
        setTipoCambio(monedaLista.valor_peso)
      }
    });  
    setImporte(parseFloat(abono));
    setRestanteImporte(parseFloat(abono))
  };

  //rz Metodo para obtener el id
  const getIdFormaPago = (value) =>{
    //console.log("Forma de pago seleccionada= "+ value);
     ListaFormaPago.map(function (fpago){
      if(fpago.nombre === value){
        //console.log("id de forma de pago obtenida = "+fpago.idFormaPago);
        setIdFormaPago(fpago.idFormaPago);
      }
    });
  };

  useEffect( () => {
    getReferencia().then(async (result)=>{
      setReferencia("")
      setDescripcion(result && result.descripcion? result.descripcion: "");
      if (result && result.referencia === "1"){
        setreferenciahay(true);
      }else{
        setreferenciahay(false);
      }
    });
  }, [formaPago]);

  async function getReferencia(){
    let result = ListaFormaPago.filter(fpago => fpago.nombre === formaPago)[0];
    return result;
  }

  const setImporteAbono = async (factura, abonoNew) =>{      
    let res = importe;
    let tmpAbono = factura.abono;    
    let tmpRes = restanteImporte-abonoNew;
    let resTmp = tmpRes
    //console.log(parseFloat(tmpAbono), parseFloat(abonoNew), restanteImporte, resTmp )
    if ( Number.parseFloat(parseFloat(restanteImporte + parseFloat(tmpAbono)) - parseFloat(abonoNew) ).toFixed(2)<0){
      setMensaje(types.MAS_TOTAL);
    }
    else if (parseFloat(abonoNew) <= parseFloat(factura.tmp_saldo)){
      factura.abono = parseFloat(abonoNew);
    }
    else if (parseFloat(abonoNew) === 0 || abonoNew === ""){
      factura.abono = parseFloat(0);
    }
    await facturas.forEach(element => {
      res = Number.parseFloat(res).toFixed(2) - parseFloat(element.abono);
    });    
    setRestanteImporte(res);
  }

  async function isOk ( pagoAnticipo ){
    //setCargando(true);
    setOpen(false)
    let flag = true;
    console.log(referenciahay, referencia, referencia.length)
    if ( (referenciahay && referencia === "") || (referenciahay && referencia.length <4) ){
      setMensaje(types.SIN_REFERENCIA);
      setVisible(true)
      flag = false;
      return flag
    }else if (  parseFloat(importe) === 0 ||  importe === "" ||  isNaN(importe)){
      setMensaje(types.IMPORTE_CERO);
      setVisible(true)
      flag = false;
      return flag
    } else if ( (cuenta === "") ){
      setMensaje(types.SIN_CUENTA);
      setVisible(true)
      flag = false;
      return flag
    } 
    if ( saldoAFavor === types.FORMA_FATURAS){
      let importeFinal = 0;
      let mayorASaldo = false;
      let contadorFacturasSaldadas = 0;
      let newfacturas = facturas;
      let tmps = newfacturas;
      await tmps.forEach(element => {
        if ( parseFloat(element.abono) > parseFloat(element.tmp_saldo) ){
          mayorASaldo = true;
        }
        if ( pagoAnticipo ){
          //console.log(  parseFloat(element.abono) , parseFloat(element.tmp_saldo))
          if (parseFloat(element.abono) === parseFloat(element.tmp_saldo)){
            contadorFacturasSaldadas = contadorFacturasSaldadas +1;
          }
        }
        importeFinal = parseFloat(element.abono) + parseFloat(importeFinal);
      });
      let mismosaldo = contadorFacturasSaldadas === facturas.length?true:false
      //console.log(importeFinal, parseFloat(abonoMaximo), importe, contadorFacturasSaldadas, pagoAnticipo, facturas.length);
      if( parseFloat(importeFinal).toFixed(2) > parseFloat(importe) && !pagoAnticipo){
        setMensaje(types.MAS_TOTAL);
        flag = false;
      } else if ( parseFloat(importeFinal).toFixed(2) < parseFloat(importe) && !pagoAnticipo){
        setMensaje(types.MENOS_TOTAL);
        flag = false;
      } else if ( mayorASaldo ){
        setMensaje(types.MAS_FACTURA);
        flag = false;
      } else if ( !mismosaldo && pagoAnticipo){
        setMensaje(types.MENOS_FACTURA_ABONO);
        flag = false;
      }
      // setCargando(false);
      if (!flag){
        setVisible(true);
      }else{
        setPagoFinal(pagoAnticipo? types.MIXTO: types.ABONO);
      }
    }else{
      if (  parseFloat(importe) === 0 ||  importe === "" || isNaN(importe)){ 
        setMensaje(types.IMPORTE_CERO);
        setVisible(true);
      } else{
        setPagoFinal(types.ANTICIPO);
      }
      console.log(importe)
    }    
    setCargando(false);
    return flag;
  }

  function agregarCero(input, length, padding) { 
    let str = input + "";
    return (length <= str.length) ? str : agregarCero(padding+str, length, padding);
  }

  async function setPagoFinal(tipo){
    let importeFinal = 0;
    let mayorASaldo = false;
    let {numero_vendedor, vendedor_nombre, VKBUR, VKORG }= syncs.vendedor;
    let final = null;
    let facturasAbonadas = [];
    let facturasNoAbonadas = [];
    let newfacturas = facturas;
    let tmps = newfacturas;
    let enviado = enviarCorreo?"0":"1";
    await tmps.forEach(element => {
      let emement = element ;
      if ( parseFloat(element.abono) > parseFloat(element.tmp_saldo) ){
        mayorASaldo = true;
      }
      let fa = {
        BELNR: emement.BELNR+ "",
        BLDAT: emement.BLDAT+ "",
        BUDAT: emement.BUDAT+ "",
        DMBTR: emement.DMBTR+ "", 
        KUNNR: emement.KUNNR+ "",
        KUNN2: emement.KUNN2 && emement.KUNN2? emement.KUNN2: ""+ "",
        WAERS: emement.WAERS+ "",
        WRBTR: emement.WRBTR+ "",
        ZTERM: emement.ZTERM+ "", 
        abono: parseFloat(element.abono).toFixed(2),
        tmp_saldo: element.tmp_saldo
      }
      if( (parseFloat(element.abono) >0) ){
        facturasAbonadas.push(fa);
      }else{
        facturasNoAbonadas.push(fa)
      }
      importeFinal = parseFloat(element.abono) + parseFloat(importeFinal);
    });
    if ( tipo === types.ANTICIPO || tipo === types.MIXTO){
      let folio = await agregarCero(num_ticket, 4, "0");
      folio = moment(new Date()).format("YYMMDD") + folio;
      let fa = {
        BELNR: folio,
        BLDAT: moment(new Date()).format("YYYY-MM-DD"),
        BUDAT: moment(new Date()).format("YYYY-MM-DD"),
        DMBTR: "0", 
        KUNNR: cliente.KUNNR,
        WAERS: moneda,
        WRBTR: "0",
        ZTERM: "0", 
        abono: tipo === types.ANTICIPO? parseFloat(importe).toFixed(2): parseFloat(importe - importeFinal).toFixed(2) ,
        tmp_saldo: "0"
      }
      //console.log(fa)
      facturasAbonadas.push(fa);
    }
    //console.log(facturasAbonadas)
    let a = facturasAbonadas;
    getLastTicket(numero_vendedor).then(async (ultimoFirestore)=>{
      let ultimo = ultimoFirestore && ultimoFirestore.num_ticket? ultimoFirestore.num_ticket: 1;
      let tmpNumero = num_ticket;
      if (ultimo >= num_ticket){
        ultimo++;
        setNum_ticket(ultimo);
        tmpNumero = ultimo;
      }
      //console.log(ultimo, num_ticket)
      let email = cliente.EMAIL;
      let emailCC = [];
      emailCC.push(cliente.EMAIL2)
      let comprobanteUrl = null;
      info = {
        cancelado: "0",
        fechaCancelado: "",
        importe_total: importe,
        dispositivo: "web",
        facturas_abono: a,
        otras_facturas: facturasNoAbonadas,
        fecha_abono: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        moneda_pago: moneda,
        num_ticket: tmpNumero,
        cliente: cliente.KUNNR,
        cliente_nombre: cliente && cliente.KTOKD === "ZPGL"? nombrePGL:cliente.NAME1,
        forma_Pago: formaPago,
        referencia: referencia,
        vendedor_nombre: vendedor_nombre,
        vendedor: numero_vendedor,
        tipo_cambio: tipoCambio,
        via: "Web",
        guardado_sap: "0",
        id_ticket: numero_vendedor + "_" + tmpNumero,
        VKBUR: cliente.VKBUR,
        tipo: tipo,
        VKORG: cliente.VKORG,
        comentarios: descripcion && descripcion? descripcion: "",
        enFirebase: "0",
        refBanco: cliente && cliente.TTX_NUMBER? cliente.TTX_NUMBER: "No registrada",
        actualizar: "0",
        refDeposito: "0",
        rechazado: "0",
        folioRechazo: "",
        comentariosRechazo: "",
        fechaRechazo: "",
        email,
        enviado,
        emailCC,
        id_forma_Pago:idFormaPago, //rz prueba para agregar valor
        cuenta:cuenta, //rz
        id_cuenta:idCuenta, //rz
        comprobante_url: comprobanteUrl,
      }
      // If a temporary comprobante was selected, upload it to Firebase Storage
      if (comprobanteFile) {
        try {
          const extParts = (comprobanteFile.name || '').split('.');
          const ext = extParts.length > 1 ? extParts.pop().toLowerCase() : '';
          const fileName = `${tmpNumero}_${numero_vendedor}` + (ext ? `.${ext}` : '');
          const storagePath = `COMPROBANTES/${fileName}`;
          const storageRef = firebase.storage().ref().child(storagePath);
          const snapshot = await storageRef.put(comprobanteFile);
          const url = await snapshot.ref.getDownloadURL();
          comprobanteUrl = url;
          info.comprobante_url = comprobanteUrl; // field name in Firebase
          console.log('Comprobante subido con éxito:', comprobanteUrl);
        } catch (err) {
          console.error('Error subiendo comprobante:', err);
          setMensaje('Error al subir comprobante');
          setVisible(true);
        }
      }
      let nex = dispatch({type:"TICKETS_ADD", payload: { ticket: info } }); //Donde se genera el ticket
      if (nex){
        let b1 = cliente.facturas; 
        let b2 = info.facturas_abono;
        let resa = cliente && cliente.KTOKD === "ZPGL"? []:b1.filter(item1 => !b2.some(item2 => (item2.BELNR === item1.BELNR )));
        //console.log("aqui", resa)
        await setOtrasFact(resa);
        final = await setTicket( info );   
        setTicketPDF(info);
        setCargando(true);
        generarPDF();
        setMensaje(final);      
        let newData = Object.assign({}, info);
        newData.enFirebase = "1";
        const { tickets } = syncs;
        let tmpTickets = await tickets.slice().filter(elm => elm.id_ticket !== info.id_ticket);
        tmpTickets.push(newData)
        dispatch({type:"TICKETS_UPDATE", payload: { ticket: tmpTickets } });
      }
    });
  }

  async function generarPDF (){
    setPrint(true);
    window.scrollTo(0, 0)
    await retardo(2000);
    setPdf()
  }

  function setPdf(){
    let input = document.getElementById('pdfdiv');
    let divHeight = input.clientHeight>1200?1200:input.clientHeight;
    let divWidth = input.clientWidth
    let ratio = divHeight / divWidth;
    html2canvas(input, { scale: '2',  }).then((canvas) => {
      let imgData = canvas.toDataURL('');
      let pdfDOC = new jsPDF("p", "pt", "a4");
      let width = pdfDOC.internal.pageSize.getWidth();
      let height = pdfDOC.internal.pageSize.getHeight();
      height = ratio * width;      
      pdfDOC.addImage(imgData, 'JPEG', 25, 0, width - 20, height - 10);
      pdfDOC.save(info.id_ticket + ".pdf");
    }).then(() =>{
      setPrint(false);
      setCargando(false);
      setImporte(0);
      setCliente(null);
      dispatch({type:"CLIENTE_COBRAR", payload: { clienteCobrar:null } });
      setVisible(true);
    })
  }

  return (
    <>
      {cargando?
        <div className="box">
          <div style={{display: "flex", justifyContent:"center"}} >
            <CircularProgress color="primary" size={300}/>
          </div>
          <br/>
          <br/>
          <div style={{display: "flex", justifyContent:"center"}} >
            <span style={{fontWeight: 'bold', fontSize: 20, alignSelf: "center"}}>Guardando...</span>
          </div>
          <Dialog
            open={print}
            onClose={handleClosePdf}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            key={"dialogoPDF_" + num_ticket}
            disableEscapeKeyDown
            maxWidth="lg"
          >
            {print?<CreatePDF pdf={ticketPDF} reimpresion={false} key={"ticket" + num_ticket} otrasFact={otrasFact}/>:null}
          </Dialog>
        </div>
        
      :
      <div className="box">
        <div className="datos">
        <React.Fragment> 
          <CustomMain>
            <CustomAutocomplete
              id="country-select-demo"
              style={{ minWidth: 270, width: '100%' }}
              options={clientes}
              onChange={handlePick}
              autoHighlight
              getOptionLabel={(option) =>  option.KUNN2 + "-" + option.KUNNR + "-" + option.NAME1 }
              renderOption={(props, option) => {
                const { key, ...rest } = props;
                return (
                  <ListItem key={key} {...rest}>
                    {`${option.KUNN2}: ${option.KUNNR} - ${option.NAME1}`}
                  </ListItem> 
                ); 
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Buscar cliente"
                  variant="outlined"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'new-password', // o 'new-password'
                  }}
                />
              )}
            
            /> 
          {cliente? 
            <>   
            <CustomPaper>
              <React.Fragment>            
                <Typography variant="h6" >
                  Administrativo: {vendedor.vendedor_nombre}
                </Typography>
                <Divider />
                <Typography variant="h6" >
                  Cliente asignado al vendedor: {cliente.KUNN2}
                </Typography>
                <Divider />
                {cliente && cliente.KTOKD === "ZPGL"? 
                    <>
                    <Typography variant="h6" >
                      {`Cliente: `} 
                    </Typography>
                    <TextField id="nombre-input"  variant="outlined" value={nombrePGL} onChange={(value)=>handleChangeNombrePGL(value)} /></>
                    : 
                    <Typography variant="h6" >
                    {`Cliente:  ${cliente && cliente.NAME1?cliente.NAME1.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}): ""}`} 
                  </Typography>}

                {/* //// Forma de Pago \\\\\ */}
                <Divider />
                  <Typography variant="h6" sx={{color: '#3f51b5'}} >
                    Forma de pago: {formaPago}
                  </Typography>
                  <RadioGroup aria-label="gender" name="gender1" value={formaPago} onChange={ value => handleChangeMetodo(value) } >
                    { ListaFormaPago.map(pagos => {
                      return <FormControlLabel 
                              label={pagos.nombre} 
                              value={pagos.nombre} 
                              color="primary"
                              key={"radio"+pagos.nombre} 
                              control={<Radio />} />
                      })
                    }
                  </RadioGroup>


                  {/* ///rz1 Select de cuenta bancaria */}
                <Divider />
                    <Typography variant="h6" sx={{paddingTop: 1, paddingBottom: 1, color: '#3f51b5'}}>
                      Cuentas Bancarias
                    </Typography>
                  <AutocompleteCuentas
                    id="country-select-demo2"
                    options={cuentas}
                    value={selectedCuentaObj}
                    onChange={handlePickCount}
                    autoHighlight
                    isOptionEqualToValue={(option, value) => option && value ? (option.idCuenta + "") === (value.idCuenta + "") : false}
                    getOptionLabel={(option) => formatCuentaLabel(option)}
                    renderOption={(props, option) => {
                      const {key, ...rest} = props;
                      return(
                        <li key={key}{...rest}>
                        {formatCuentaLabel(option)}
                      </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Seleccione banco"
                        variant="outlined"
                        autoComplete="new-password"
                      />
                    )}
                    
                  />
                  {/* /// fin */}
                  
                  { referenciahay ?
                    <>
                    <Typography variant="h6" >
                    Guia CIE :  {referencia}
                    </Typography>
                    <TextField id="referencia-input"  type="number" variant="outlined" value={referencia} onChange={(value)=>handleChangeReferencia(value)} />
                    </>
                    :null
                  }                  

                  <Divider />
                  <Typography variant="h6" >
                    Tipo de cobranza: {saldoAFavor}
                  </Typography>
                  <Divider />
                  <Typography variant="h6" >
                    Moneda: {moneda}
                  </Typography>
                  <RadioGroup aria-label="moneda" name="moneda1" value={moneda} onChange={ (value) => {handleChangeMoneda(value); getImporte(0); setImporte("0"); }} >
                    { listaMoneda.map(monedas => {
                      return <FormControlLabel 
                              label={monedas.nombre} 
                              value={monedas.nombre} 
                              color="primary"
                              key={"radio"+monedas.nombre} 
                              control={<Radio />} />
                      })
                    }
                  </RadioGroup>
                  { tipoCambio !== "1"?  
                    <Typography variant="h6" >
                      {`Tipo de cambio: ${tipoCambio} pesos`} 
                    </Typography>             
                  : null}
                  <Divider />
                  <Typography variant="h6" >
                    {`Ticket:  ${num_ticket}`} 
                  </Typography>
                  <Divider />
                  <div style={{display:'flex', alignItems:'center', justifyContent:'center', gap:8, marginTop:8}}>
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{display:'none'}}
                      accept=".png,.jpeg,.jpg,.pdf"
                      onChange={handleSelectComprobante}
                    />
                    <Button variant="contained" color="primary" onClick={triggerSelectComprobante}>
                      Selecciona comprobante
                    </Button>
                  </div>
                  <div style={{marginLeft:12, marginTop:8,justifyContent:'center',display:'flex', alignItems:'center'}}>
                      {comprobanteLoaded ? <><CheckCircleIcon style={{color:'green', marginRight:6}}/>{comprobanteName}</> : <span>Sin comprobante</span>}
                    </div>
                  <Typography variant="h6" >
                    Importe total:  MXN {formatCurrency(importe)}
                  </Typography>
                  <TextField id="importe-input"  variant="outlined" onChange={(value)=>handleChangeImporte(value)} />
                  <br/>
                  <Button variant="contained" 
                    style={{
                      marginTop:20, 
                      marginBottom:20,
                      alignItems:"center", 
                      width:"100%", 
                      alignSelf:"center", 
                      elevation:.5, 
                      alignContent:"center"
                    }} 
                    color="primary"
                    onClick= {() =>{setOpen(true)}}
                    //{async () =>{ console.log("cobranso")}}
                  >
                    Cobrar
                  </Button>

              </React.Fragment>
            </CustomPaper>
          </>
          :null}           
        </CustomMain>
      </React.Fragment>
      </div>        

      <div className="three" 
        style={{zoom: facturas?.some(fact => fact.tmp_saldo > 0) && window.innerWidth <=934 ? 0.4 : 1}}
        >
        {facturas && facturas.length > 0?
        <div>
          <div style={{display: "flex", justifyContent:"space-between"}}>
          <div></div>
          <div style={{alignSelf: "flex-end", fontSize: 20}}>{`Restante: ${formatCurrency(restanteImporte)}`} </div></div>
          <div>
          <TableContainer>
            <Table stickyHeader aria-label="sticky table" key="tabla clientes">
              <TableHead>
                <TableRow>
                  <TableCell key={"fact"} align={"center"}> Factura  </TableCell>
                  <TableCell key={"fact-FE"} align={"center"}> Fecha factura </TableCell>
                  <TableCell key={"fact-VE"} align={"center"}> Fecha vencimiento </TableCell>
                  <TableCell key={"fact-MO"} align={"center"}> Monto </TableCell>
                  <TableCell key={"fact-SA"} align={"center"}> Saldo </TableCell>
                  <TableCell key={"fact-AB"} align={"center"}> Abono  </TableCell>
                  <TableCell key={"fact-AN-IN"} align={"center"}> Abono  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                { facturas.map( (fact, index) =>{
                  return(
                    <React.Fragment key={"fila-fragment-" + fact.BELNR}>
                      {fact.tmp_saldo >0 ? 
                        <TableRow key={"fila" + fact.BELNR} hover role="checkbox" tabIndex={-1} >
                          <TableCell>{fact.BELNR}</TableCell>
                          <TableCell>{fact.BUDAT}</TableCell>
                          <TableCell>{fact.BLDAT}</TableCell>
                          {/* <TableCell>{fact.WAERS}</TableCell> */}
                          <TableCell>{formatCurrency(fact.DMBTR)}</TableCell>
                          <TableCell onClick={(value)=>handleChangeImporteFactClick(fact, value)}> 
                            <Button sx={{color:'white', backgroundColor:'#3f51b5',}}>{formatCurrency(fact.tmp_saldo)}</Button> 
                          </TableCell>                           
                          <TableCell>{formatCurrency(fact.abono)}</TableCell>
                          <TableCell>
                          <TextField variant="outlined" 
                          style={{    margin: 10,width: 120 }}
                          onChange={(value)=>handleChangeImporteFact(fact, value)}
                          key={"input" + fact.BELNR + fact.BUDAT}
                          />
                          </TableCell>
                        </TableRow>
                      :null}
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          </div>
        </div>
          :null}
      </div>

      <Dialog
          open={open}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          key={"dialogo-cobro-" + num_ticket}
        >
          <DialogTitle id="alert-dialog-title">
              {parseFloat(importe) > parseFloat(abonoMaximo) && saldoAFavor === types.FORMA_FATURAS? 'Captura de cobro'
              :saldoAFavor === types.FORMA_ABONO? 'Anticipo'
              :'Captura de cobro'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            {parseFloat(importe) > parseFloat(abonoMaximo) && saldoAFavor === types.FORMA_FATURAS? `Queda un saldo de ${formatCurrency(importe - abonoMaximo)}\n¿Deseas registrarlo como anticipo?`
              :saldoAFavor === types.FORMA_ABONO? `¿Deseas registrar el anticipo de ${formatCurrency(importe)}?`
              :`¿Estas seguro de registrar el cobro?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={async ()=>{
                  if (parseFloat(importe) > parseFloat(abonoMaximo) && saldoAFavor === types.FORMA_FATURAS ){
                    isOk(true)
                  }else if ( saldoAFavor === types.FORMA_ABONO ){
                    isOk(false)
                  }else{
                    isOk(false)
                  }
                }} 
              color="primary">
              Sí
            </Button>
            <Button onClick={handleCloseDialog} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>}
      <Snackbar open={visible} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={handleClose} severity={mensaje === types.REGISTRO_OK? "success":"error" }>
          {mensaje}
        </Alert>
      </Snackbar>
    </>
  );
}
